import React, { type SyntheticEvent } from 'react';
import { styled } from '@compiled/react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import { AnalyticsEventToProps } from '@atlassian/jira-product-analytics-bridge';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import messages from './messages';

type Props = Intl & {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	onClick: (arg1: SyntheticEvent<any>, arg2: UIAnalyticsEvent) => void;
};

const HowToReadComponent = ({ onClick, intl }: Props) => (
	// @ts-expect-error onClick event type doesn't match DOM event
	<HowToReadText onClick={onClick}>{intl.formatMessage(messages.howToRead)}</HowToReadText>
);

const HowToReadComponentWithAnalytics = AnalyticsEventToProps('reportPageHeader', {
	onClick: 'howToToggled',
})(HowToReadComponent);

export default injectIntl(HowToReadComponentWithAnalytics);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HowToReadText = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.brand', colors.B400),
	cursor: 'pointer',
});
